export const DUPLICATE_WORKSPACE = `
  mutation DuplicateWorkspace($input: DuplicateWorkspaceInput!) {
    workspace {
      duplicateWorkspace(input: $input) {
        workspaceId
        ownerId
        copiedActivities
        copiedAssets
        copiedRoutines
        copiedPeople
        copiedAlerts
        copiedGroups
      }
    }
  }
`;
